import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import cx from 'classnames/bind';

const ProfileMetrics = ({taskCaller}) => {
    const [type, setType] = useState('');

    const onClick = () => {
        if(!type) return alert("Select something!");
        taskCaller({type});
    }

    return (
        <div>
            <div className="profile-metrics">
                Queue Profile Metrics:
                <div className={cx("form-group")}>
                    <label htmlFor="">Select type: </label>
                    <select id="type" value={type} onChange={e => setType(e.target.value)} >
                        <option value="">select</option>
                        <option value="insta">Insta</option>
                    </select>
                </div>
                <button type="button" onClick={onClick}>Queue</button>
            </div>
        </div>
    );
}

export default ProfileMetrics;